import React, { useState, useEffect, useCallback, useMemo } from 'react';
import Tooltip from "../common/Tooltip";
import { v4 as uuidv4 } from 'uuid';


const EllipsisToolTip = (props) => {
    const {tooltip, placement='right', className} = props;
    const [showTooltip, setShowTooltip] = useState(false);
    const tid = useMemo(() => (uuidv4()), []);

    // MOUSE ENTER HANDLER
    const mouseEnterHandler = useCallback((e) => {
        if ((e.target.offsetWidth !== e.target.scrollWidth) && !showTooltip) {
            setShowTooltip(true);
        }
        else if ((e.target.offsetWidth === e.target.scrollWidth) && showTooltip) {
            setShowTooltip(false);
        }
    }, [showTooltip, setShowTooltip])


    return (
        <>
            {(!showTooltip || !tooltip) &&
                <div data-tip data-for={tid} className={'ch-overflow-ellipse' + (className !== undefined ? ' ' + className : '')} onMouseEnter={mouseEnterHandler} style={props.style}>
                    {props.children}
                </div>
            }
            {showTooltip && tooltip &&
                <Tooltip title={tooltip} arrow interactive={false} enterNextDelay={100} placement={placement}>
                    <div data-tip data-for={tid} className={'ch-overflow-ellipse' + (className !== undefined ? ' ' + className : '')} onMouseEnter={mouseEnterHandler} style={props.style}>
                        {props.children}
                    </div>
                </Tooltip>
            }
        </>
    )
}

export default EllipsisToolTip;